
class AddAds {
    constructor() {
        this.postContent = document.querySelector(
            ".single-post__content-proper"
        );
        this.findFirstParagraph();

    }

     findFirstParagraph(){
        if(this.postContent){
            let paragraphs = this.postContent.querySelectorAll('p');

            paragraphs.forEach((paragraph, key)=>{
                if(key === 0 || key === 3){
                    let ad = document.createElement('div');
                    ad.style.margin = "15px";
                    key === 0 ?  ad.classList.add('article_ad_1') : ad.classList.add('article_ad_2');
                    paragraph.appendChild(ad);
                }
            })
        }
    }
}
export default AddAds;